// 挂账记录dlg组件

const onAccountDlg = {
  namespaced: true,

  state: {
    dlgShow: false,

    list: [],

    code: ""
  },

  getters: {
    dlgShow: state => state.dlgShow,

    list: state => state.list,

    code: state => state.code
  },

  mutations: {
    SET_DLGSHOW: (state, val) => {
      state.dlgShow = val
    },

    SET_LIST: (state, val) => {
      state.list = val
    },

    SET_CODE: (state, val) => {
      state.code = val
    },
  },

  actions: {

  }
}

export default onAccountDlg
